import React from 'react';
import {
    Box,
    Button,
} from '@mui/material';
import Page from '../../components/Page';
import { useAppUrls, useDownloadApp } from '../../hooks/useAppResources';

function AppDownload(){
    const { data: appUrls = [] } = useAppUrls();
    const downloadApp = useDownloadApp();
    const [markedVersion, setMarkedVersion] = React.useState();

    let highestVersion = {};

    function FindHighest(){
        highestVersion = appUrls?.reduce((a, b) =>
            0 < a?.appVersion.localeCompare(b?.appVersion, undefined, { numeric: true, sensitivity: 'base' })
                ? a
                : b
        )
        setMarkedVersion(highestVersion)
    }


    React.useEffect(() => {
        if (appUrls?.length > 0) {
            FindHighest();
        }
    }, [appUrls]);

    return (
        <Page title="App Download">
        <Box sx={{margin: "5%"}}>
            <h2>Botmark Application Download</h2>
            <ul className="processorList" style={{padding: 'inherit'}}>
                { appUrls?.map((app, i) => {
                        return (
                            <div key={i} i={i} className="processorIndex">
                                { app?.appVersion == markedVersion?.appVersion ?
                                <div style={{border: "green solid 2px", borderRadius:'5px'}}>
                                    <p style={{color:'green'}}>LATEST</p>
                                    <h3>{app?.appVersion.split(".Installer.zip")}</h3>
                                    <Button onClick={() => downloadApp.mutate({ id: app.id, appVersion: app.appVersion })} >Download</Button>
                                </div>
                                :
                                <div>
                                    <h3>{app?.appVersion.split(".Installer.zip")}</h3>
                                    <Button onClick={() => downloadApp.mutate({ id: app.id, appVersion: app.appVersion })} >Download</Button>
                                </div>
                                }
                            </div>
                        )
                    })
                }
            </ul>
        </Box>
        </Page>
    )
};

export default AppDownload;
